var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 1.81332L16.5285 1.1646C16.3359 0.933568 16.0507 0.799988 15.75 0.799988C15.4493 0.799988 15.1641 0.933568 14.9715 1.1646L15.75 1.81332ZM5.61667 13.9733L4.8382 13.3246C4.55796 13.6609 4.52535 14.1392 4.75736 14.5104L5.61667 13.9733ZM15.75 30.1867L14.8907 30.7237C15.0759 31.02 15.4006 31.2 15.75 31.2C16.0994 31.2 16.4241 31.02 16.6093 30.7237L15.75 30.1867ZM25.8833 13.9733L26.7426 14.5104C26.9747 14.1392 26.9421 13.6609 26.6618 13.3246L25.8833 13.9733ZM15.75 9.91999L16.1264 8.97913L15.75 8.82859L15.3736 8.97913L15.75 9.91999ZM14.9715 1.1646L4.8382 13.3246L6.39513 14.622L16.5285 2.46204L14.9715 1.1646ZM4.75736 14.5104L14.8907 30.7237L16.6093 29.6496L6.47597 13.4363L4.75736 14.5104ZM16.6093 30.7237L26.7426 14.5104L25.024 13.4363L14.8907 29.6496L16.6093 30.7237ZM26.6618 13.3246L16.5285 1.1646L14.9715 2.46204L25.1049 14.622L26.6618 13.3246ZM5.99302 14.9142L16.1264 10.8608L15.3736 8.97913L5.24032 13.0325L5.99302 14.9142ZM15.3736 10.8608L25.507 14.9142L26.2597 13.0325L16.1264 8.97913L15.3736 10.8608Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.4,
    height: 30.4,
    fill: "white",
    transform: "translate(0.549988 0.799988)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.6a15373d51963b823a4f18de6eb44d40.svg";
export { ForwardRef as ReactComponent };